import * as MODULES from '../module-codes'
import axios from 'axios'
import { stackOffsetSilhouette } from 'd3'

export const state = {
  currentState: {
    Phishing: {
      investment: '',
      aro: 0,
      ef: 0
    },
    Ransomware: {
      investment: '',
      aro: 0,
      ef: 0
    },
    SCADA: {
      investment: '',
      aro: 0,
      ef: 0
    },
    WebAttacks: {
      investment: '',
      aro: 0,
      ef: 0
    },
  },
  submissions: [],
  eventToTrigger: null,
}

export const getters = {}

export const actions = {
  submit: async ({commit, dispatch, state}) => {
    try {
      let submission = JSON.parse(JSON.stringify(state.currentState))
      submission.Timestamp = new Date()
      state.submissions.push(submission)
      dispatch("broadcastState")
      dispatch("events/processEvent", { eventId: state.eventToTrigger }, { root: true });
      dispatch("events/logAction", {
        action: "Risk Assessment",
        content: submission
      }, { root: true });
    } catch (err) {
      await axios.post('/api/log_error', {
        params: {
          error: err.message,
        }
      })
      console.log("Failed")
      console.log(err)
      return false
    }
  },
  setCurrentStateProperty: async ({ commit, dispatch }, payload) => {
    commit("SET_CURRENT_STATE_PROPERTY", payload)
  },
  setSubmissions: async ({ commit, dispatch }, payload) => {
    commit("SET_SUBMISSIONS", payload)
  },
  populateFromDB: async ({ commit, dispatch }, payload) => {
    dispatch('populateRiskAssessmentFromDB')
    dispatch('populateRiskAssessmentSettings')
    if (payload) {
      commit("POPULATE_FROM_DB", payload)
    }
  },
  broadcastState: async ({commit, dispatch, state, rootState}) => {
    await axios.post('/api/update_risk_assessment', {
      params: {
        pcs: localStorage.getItem('pcs'),
        state: state,
        classId: rootState.auth.classId
      }
    }) 
  },
  broadcastUpdate: async ({commit, dispatch, state, rootState}, {section, field}) => {
    await axios.post('/api/update_risk_assessment', {
      params: {
        pcs: localStorage.getItem('pcs'),
        section: section,
        field: field ?? null,
        value: state.currentState[`${section}`],
        classId: rootState.auth.classId
      }
    }) 
  },
  updateState: ({commit}, payload) => {
    commit("UPDATE_STATE", payload)
  },
  populateRiskAssessmentFromDB: async ({ commit, state, rootState }) => {
    axios.post('/api/pcs/riskAssessmentGroup', {
      params: {
        group: rootState.group.group.id
      }
    }).then(res => {
        if(res.data){
          commit("POPULATE_FROM_DB", res.data['content'])
        }
    })
  },
  getUpdateBySection: async ({ commit }, payload) => {
    if(payload.section && payload.field){
      commit('SET_CURRENT_STATE_PROPERTY', {...payload, value: payload.data.currentState[payload.section][payload.field]})
    }
    else {
      commit("POPULATE_FROM_DB", payload.data)
    }
  },
  populateRiskAssessmentSettings: async ({ commit }) => {
    axios.post('/api/pcs/riskAssessment', {
        params: {
            pcs: localStorage.getItem('pcs')
        }
    }).then(res => {
        commit("SET_RISK_EVENT_TO_TRIGGER", res.data['settings'])
    })
  },
}

export const mutations = {
  POPULATE_FROM_DB: (state, payload) => {
    if (payload.currentState) {
      let defaultObj = { investment: '', aro: 0, ef: 0 }
      state.currentState.SCADA = payload.currentState.SCADA ?? defaultObj
      state.currentState.Phishing = payload.currentState.Phishing ?? defaultObj
      state.currentState.Ransomware = payload.currentState.Ransomware ?? defaultObj
      state.currentState.WebAttacks = payload.currentState.WebAttacks ?? defaultObj
    }
    if (payload.submissions) state.submissions = payload.submissions ?? []
  },
  SET_CURRENT_STATE_PROPERTY: (state, payload) => {
    state.currentState[payload.section][payload.field] = payload.value
  },
  UPDATE_STATE: (state, payload) => {
    state = payload
  },
  SET_RISK_EVENT_TO_TRIGGER: (state, payload) => {
    state.eventToTrigger = payload.eventToTrigger
  },
  SET_SUBMISSIONS: (state, payload) => {
    state.submissions = payload
  },
}
